import React from 'react';

import { Box } from '@wds/box';
import { Grid } from '@wds/grid';

import useStyles from './useStyles';

export type Props = {
  hasSplitBackgroundColor?: boolean;
  imageSource: string;
  // @todo: https://momentiveai.atlassian.net/browse/ANONWEB-5448
};

export default function EndpageImage({ hasSplitBackgroundColor = false, imageSource }: Props): React.ReactElement {
  const { container, image } = useStyles({ hasSplitBackgroundColor, imageSource });
  return (
    <Box className={container}>
      <Grid noBleeds noGutters px={5}>
        <Grid.Item lg={3}>
          <></>
        </Grid.Item>
        <Grid.Item lg={6} xs={12}>
          <div className={image} data-testid="EndpageImage__ImageDiv">
            <></>
          </div>
        </Grid.Item>
        <Grid.Item lg={3}>
          <></>
        </Grid.Item>
      </Grid>
    </Box>
  );
}
